import React, { Fragment } from "react";
import { Box, Container, Grid } from "@mui/material";
import ActivityCard from "../../example/home/activity/ActivityCard";
import PageHeader from "../../example/pages-header/PageHeader";
import NoData from "../../components/no-data/NoData";
import ErrorPage from "../../components/error/Error";
import useFetchObjects from "../../api/useFetchObjects";
import ActivitiesSkeleton from "./loading/ActivitiesSkeleton";
import SEO from "../../components/ceo/CEO";

const Activities = () => {
  const { data, isLoading, isError, isSuccess, error, refetch } =
    useFetchObjects(["Activities"], "activities");

  if (isLoading) {
    return <ActivitiesSkeleton />;
  }

  if (isError) {
    return <ErrorPage errorMessage={error.message} refetch={refetch} />;
  }

  if (isSuccess && (!data || data.length === 0)) {
    return <NoData refetch={refetch} />;
  }

  if (isSuccess) {
    return (
      <Fragment>
        <SEO
          title="Our Activities"
          description="Explore the impactful activities organized by SHALL Social and Development Organization, focusing on community growth, education, and social justice."
          url="https://shallafg.org/activities"
          image="https://shallafg.org/media/images/logo.png"
        />
        <PageHeader
          title="Our Activities"
          subtitle="Discover the wide range of activities that drive our mission. We
              focus on delivering impactful services, fostering community
              growth, and advancing knowledge through our key areas of
              expertise."
        />
        <Box
          sx={{
            backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
            color: "#FFFFFF",
            paddingY: "100px",
          }}
        >
          <Container maxWidth="lg">
            {/* Activities Grid */}
            <Grid container spacing={6}>
              {data.map((activity) => (
                <Grid item xs={12} sm={6} md={4} key={activity.id}>
                  <ActivityCard activity={activity} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Fragment>
    );
  }
};

export default Activities;
